export const appInfo = {
    version: '1.1.6',
    name: 'Products search',
    acronym: 'PWS :: PRO'
}
